/**
 * This file is to map send email action , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { emailAPIActionEvent } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import store from "assets/js/store";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { getAllPreviousEventsByEventType } from "assets/js/scenes/automations/containers/editor/utils/utils";

const parseBEEmailAPIToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		type: "editorNode",
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: emailAPIActionEvent()[0].name,
			desc: emailAPIActionEvent()[0].desc,
			type: "action",
			tileTitle: "app-automation-editor_events_action-1_tileTitle",
			id: mainStep.name,
			actionName: mainStep.description,
			baseId: "emailAPI",
			shadows: getShadowsForStep(automation, mainStep.name),
			content: {
				template: {
					id: subStep.args.content.template.id
				},
				subject: subStep.args.content.subject,
			},
			sender: {
				id: subStep.args.sender?.id,
				name: subStep.args.sender?.name,
			},
			tags: subStep.args.tags,
			thumbnailUrl: subStep.args.thumbnailUrl,
			additional_params: subStep.args.additional_params,
		},
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFEEmailAPIToBE = (
	FEEvent,
	connectedEdges,
	events,
	nextIndex,
	selfIndex
) => {
	let shadows = [];
	let inTos = [];
	let hasMultipleListsAsTriggers = false;

	const addFilterStepIfNeeded = () => {
		const previousSteps = getAllPreviousEventsByEventType(
			FEEvent.id,
			"type",
			"condition"
		);
		if (checkIfRecurringAutomation && (previousSteps.length < 1 || previousSteps[0]?.data?.baseId !== "filterSet")) {
			return [{
				name: "set_filter",
				action: "Variable.Set",
				args: {
					"input.data.filter": {
						"and": [
							{
								"or": [
									{
										"eq": {
											"status": "active"
										}
									}
								]
							}
						]
					}
				}
			}];
		} else {
			return [];
		}

	};
	const addStepNameToTag = (tags) => {
		if (tags[0].startsWith("automation_") && !tags[0].endsWith(FEEvent.id)) {
			tags[0] = `${tags[0]}_${FEEvent.id}`;
		}
		return tags;
	};
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);

	const checkIfRecurringAutomation = events.find(event => event.data.baseId == "onSchedule");
	hasMultipleListsAsTriggers = events.filter((e) => e.data.type === "trigger" && e.data.baseId !== "manual").length > 1;

	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				steps: [
					...addFilterStepIfNeeded(),
					{
						name: `${FEEvent.id}`,
						description: FEEvent.data.actionName,
						action: "Email.Send",
						args: {
							content: {
								template: {
									id: parseInt(FEEvent.data.content.template.id)
								},
								subject: FEEvent.data.content.subject,
								type: "marketing"
							},
							sender: {
								id: FEEvent.data.sender.id,
								name: FEEvent.data.sender.name
							},
							...(hasMultipleListsAsTriggers && { list_id: "${input.data.listId}" }),
							...(checkIfRecurringAutomation && { json: "${input.data.filter}" }),
							tags: addStepNameToTag(FEEvent.data.tags),
							...(!checkIfRecurringAutomation && { email: "${input.data.contact.email}" }),
						},
						next: getNextTarget(connectedEdges, events),
					},
					...(!checkIfRecurringAutomation ? [{
						name: "set_output",
						action: "Variable.Set",
						args: {
							[`input.data.step_trigger.${FEEvent.id}`]: `\${${FEEvent.id}_output.body.data.id}`
						},
					}] : []),
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};
export { parseFEEmailAPIToBE, parseBEEmailAPIToFE };
